import { usePathname } from "next/navigation";

export const useSymbol = () => {
  const pathname = usePathname();
  const match = pathname?.match(/\/my\/analysis\/([^/]+)/);
  return { symbol: match ? match[1] : "" };
};
